import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { getFarmacia } from "../api/userApi";
//import { getCatalog } from "../api/visitApi";
import SearchBar from "../components/SearchBar";
import Cart from "../components/Cart";
import "../css/HomePage.css";

const FarmacyProfilePage = () => {
  const { cuit } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isOwner = user?.farmacia.cuit === cuit;

  const [profileUser, setProfileUser] = useState(null);
  const [cart, setCart] = useState([]); // [{ item, cantidad }]

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Consultando cuit:", String(cuit));
        const resUser = await getFarmacia(cuit);
        console.log("Respuesta de getFarmacia:", resUser);
        setProfileUser(resUser.data.farmacia);
      } catch (error) {
        console.error("Error cargando el perfil:", error);
      }
    };

    fetchData();
  }, [cuit]);

  // El carrito es por farmacia: si cambia el cuit visitado, lo vaciamos
  useEffect(() => {
    setCart([]);
  }, [cuit]);

  if (!profileUser) return <p>Cargando perfil...</p>;

  console.log("profileUser.logo:", profileUser.logo);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleAddToCart = (item) => {
    setCart((prev) => {
      const existing = prev.find((entry) => entry.item.CLAVE === item.CLAVE);
      if (existing) {
        return prev.map((entry) =>
          entry.item.CLAVE === item.CLAVE
            ? { ...entry, cantidad: entry.cantidad + 1 }
            : entry
        );
      }
      return [...prev, { item, cantidad: 1 }];
    });
  };

  const handleUpdateCantidad = (clave, cantidad) => {
    if (cantidad < 1) return;
    setCart((prev) =>
      prev.map((entry) =>
        entry.item.CLAVE === clave ? { ...entry, cantidad } : entry
      )
    );
  };

  const handleRemove = (clave) => {
    setCart((prev) => prev.filter((entry) => entry.item.CLAVE !== clave));
  };

  const handleEjecutar = () => {
    if (cart.length === 0) return;

    const telefono = profileUser.telefono;
    if (!telefono) {
      alert("Esta farmacia no tiene un teléfono configurado para WhatsApp.");
      return;
    }

    const lineas = cart.map(
      (entry) =>
        `• ${entry.item.NOMBRE} ${entry.item.PRESENTACION} x${entry.cantidad} - $${(
          Number(entry.item.PRECIO) * entry.cantidad
        ).toFixed(2)}`
    );

    const total = cart.reduce(
      (acc, entry) => acc + Number(entry.item.PRECIO) * entry.cantidad,
      0
    );

    const mensaje =
      `Hola! Quiero hacer un pedido en ${profileUser.nombre}:\n\n` +
      lineas.join("\n") +
      `\n\nTotal: $${total.toFixed(2)}`;

    const telefonoLimpio = String(telefono).replace(/\D/g, "");
    const url = `https://wa.me/${telefonoLimpio}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="app-container">
      <div
        className="background-layer"
        style={
          profileUser.backgroundcolor
            ? { backgroundColor: profileUser.backgroundcolor }
            : undefined
        }
      ></div>
      <div
        className="portada"
        style={{
          backgroundImage: profileUser.banner
            ? `url(${profileUser.banner})`
            : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {isOwner && (
          <div className="login-header">
            <button
              className="login-button"
              onClick={() => navigate("/editar-perfil")}
            >
              Editar
            </button>
            <button className="login-button" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        )}
      </div>
      <div
        className="perfil-img"
        style={{
          backgroundImage: profileUser.logo
            ? `url(${profileUser.logo}?t=${Date.now()})`
            : undefined,
        }}
      ></div>
      <div className="search-section">
        <Cart
          items={cart}
          onUpdateCantidad={handleUpdateCantidad}
          onRemove={handleRemove}
          onEjecutar={handleEjecutar}
        />
        <SearchBar
          onAddToCart={handleAddToCart}
          backgroundColor={profileUser.backgroundcolor}
        />
      </div>
      <footer className="footer">© Farmasite</footer>
    </div>
  );
};

export default FarmacyProfilePage;